<div class="menu-container p-2 pt-3">
  <div class="menu-scrollable custom-menu">
    <p-panelMenu
      [model]="items"
      [style]="{ width: '270px' }"
      [multiple]="true"
    ></p-panelMenu>
    <div class="side-menu-logo-wrapper">
      <img class="side-menu-logo-img" src="./assets/icons/ellada2.png" alt="Ellada Logo" />
    </div>
  </div>
</div>
